import React, { useEffect, useState } from 'react';
import Sensor from './Sensor';
import SyncAnalysis from './SyncAnalysis';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const { REACT_APP_WEBSERVER, REACT_APP_PROXY_HOST } = process.env;
const VIEWMODE_LIST = 0;
const isMobile = true;

const AppareilDisplay = (props) => {
  const telId = props.telId;
  const camId = props.camId;

  const [legSensors, setLegSensors] = useState([]);
  const [syncAnalysis, setSyncAnalysis] = useState({ name: '', data: [], chrono: [] });
  const [sensors, setSensors] = useState({
    memory: { sensorTypeId: '', name: '', data: [], chrono: [] },
    battery: { sensorTypeId: '', name: '', data: [], chrono: [] },
    temperature: { sensorTypeId: '', name: '', data: [], chrono: [] },
    synclog: { sensorTypeId: '', name: '', data: [], chrono: [] },
  });
  const [viewMode, setViewMode] = useState(VIEWMODE_LIST);
  const [battery, setBattery] = useState('');
  const [version, setVersion] = useState('');
  const [temperature, setTemperature] = useState('');
  const [nameState, setNameState] = useState(props.name);
  const [statusCode, setStatusCode] = useState('');
  const [lastUpdate, setLastUpdate] = useState('');
  const [selectedTab, setSelectedTab] = useState(3);

  useEffect(() => {
    if (nameState !== props.name) {
      setNameState(props.name);
    }
    if (viewMode !== props.viewMode) {
      setViewMode(props.viewMode || VIEWMODE_LIST);
    }

    setBattery(props.battery);
    setStatusCode(props.statusCode);
    setLastUpdate(props.lastUpdate);
    setVersion(props.version);
    setTemperature(props.temperature);

    if (!telId) {
      return undefined;
    }

    const interval = setInterval(() => {
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((data) => setLegSensors(data));
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId + '/sensor/' + 1, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((sensor) => setSensors((current) => ({ ...current, memory: sensor })));
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId + '/sensor/' + 2, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((sensor) => setSensors((current) => ({ ...current, battery: sensor })));
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId + '/sensor/' + 3, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((sensor) => setSensors((current) => ({ ...current, temperature: sensor })));
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId + '/sensor/' + 5, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((sensor) => setSensors((current) => ({ ...current, synclog: sensor })));
      fetch(REACT_APP_PROXY_HOST + '/voir/appareil/' + telId + '/sync', { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.json())
        .then((sync) => setSyncAnalysis(sync));
    }, 60000);

    return () => clearInterval(interval);
  }, [props, nameState, telId, viewMode]);

  const handleOnChange = (_event, value) => {
    setSelectedTab(value);
  };

  return (
    <div>
      <Tabs className="mb-2" orientation="horizontal" indicatorColor="secondary" textColor="primary" value={selectedTab} onChange={handleOnChange} variant="scrollable" scrollButtons="on" aria-label="summary tabs">
        <Tab key={3} label="General" value={3} style={{ fontSize: isMobile ? '80%' : '100%' }} />
        <Tab key={0} label="Legacy Sensors" value={0} style={{ fontSize: isMobile ? '80%' : '100%' }} />
        <Tab key={1} label="Sensors" value={1} style={{ fontSize: isMobile ? '80%' : '100%' }} />
        <Tab key={2} label="Sync Log" value={2} style={{ fontSize: isMobile ? '80%' : '100%' }} />
      </Tabs>

      {selectedTab === 3 && (
        <div>
          <div>CamId: {camId}</div>
          <div>TelId: {telId}</div>
          <div>Batterie: {battery}</div>
          <div>Temperature: {temperature}</div>
          <div>Version: {version}</div>
          <div>Code Etat: {statusCode}</div>
          <div>Derniere mise a jour: {lastUpdate}</div>
          <div>Fichiers de log: <a href={REACT_APP_WEBSERVER + '/monitoring/' + telId}>Ici</a></div>
          <div>Page de controles alternatifs: <a href={REACT_APP_WEBSERVER + '/zadmin/interfaceAppareil.html?telId=' + telId}>Ici</a></div>
        </div>
      )}

      {selectedTab === 0 && (
        <List component="nav" aria-label="secondary mailbox folders">
          {legSensors.map((sensor, i) => (
            <ListItem button key={i}>
              <Sensor sensorType={sensor.sensorTypeId} name={sensor.name} data={sensor.data} chrono={sensor.chrono} />
              <ListItemText primary={i} />
            </ListItem>
          ))}
        </List>
      )}

      {selectedTab === 1 && (
        <div>
          NOUVEAUX SENSORS
          <Sensor sensorType={sensors.memory.sensorTypeId} name={sensors.memory.name} data={sensors.memory.data} chrono={sensors.memory.chrono} />
          <Sensor sensorType={sensors.battery.sensorTypeId} name={sensors.battery.name} data={sensors.battery.data} chrono={sensors.battery.chrono} />
          <Sensor sensorType={sensors.temperature.sensorTypeId} name={sensors.temperature.name} data={sensors.temperature.data} chrono={sensors.temperature.chrono} />
        </div>
      )}

      {selectedTab === 2 && (
        <div>
          Historique des syncs
          <Sensor sensorType={sensors.synclog.sensorTypeId} name={sensors.synclog.name} data={sensors.synclog.data} chrono={sensors.synclog.chrono} />
          <SyncAnalysis name={syncAnalysis.name} data={syncAnalysis.data} chrono={syncAnalysis.chrono} />
        </div>
      )}
    </div>
  );
};

export default AppareilDisplay;



// WEBPACK FOOTER //
// src/components/appareils/AppareilDisplay.js